import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import AppConfigService from 'app/core/app-config.service';

@Injectable({ providedIn: 'root' })
export default class PasswordService {
  constructor(private http: HttpClient) {}

  save(newPassword: string, currentPassword: string): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/account/change-password`, { currentPassword, newPassword });
  }
}
